import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';


import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';


class SettingDealerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            List: [],
            Dealers: [],
            Current: null,
            modeList: true,
            modeUpdate: false,
            newEntry: {
                Ref: "",
                Dealer:"",
                Email: "",
                Phone: "",
                Name: "",
                ContactPerson: "",
                ContactPhone: "",
                ContactAddress: "",
            },
            showPopup:false,
            selectedDealer:"",
            selectedAgent:null,
        }

    }

    async componentDidMount() {
        await this.isSupperOrDealerUser()
        await this.fetchDealers();
        await this.fetchAgents();
        await this.findInformation();

    }

    handleChange=(e,key)=>{
        let tmp = this.state;
        tmp[key]=e.target.value;
        this.setState({
            tmp
        })
    }

    isSupperOrDealerUser = async () => {
        let user = GetUserToken();
        const role = user.Role;
        if (role === "super") {
            return
        }
        if (role === "dealer") {
            return
        }

        alert("Sorry you can't perform this action,Your role is: " + role + "");
        window.location.href = "#/home"
    }
    findInformation=async ()=>{
        let _this =this;
        const user  = GetUserToken();
        let hub = {
            RequesterUsername :user.Username,
            RequesterPhone    : user.Phone,
            RequesterRole     : user.Role,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-information/user";

        console.log("findInformation send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("findInformation response > ", dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                _this.setState({
                    Information:data
                })

            }
        });
    }
    fetchAgents = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("agent", conds, (data) => {
            console.log("fetchAgents :> ", data);
            _this.setState({
                List: data,
            });
        });
    }
    fetchDealers = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("dealership", conds, (data) => {
            console.log("fetchCommissionStructure :> ", data);
            _this.setState({
                Dealers: data,
            });
        });
    }
    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }

    viewListDetail = (row) => {
        console.log("View List detail Dealer ", row);
        let o = {
            Ref: row.ref,
            Dealer:row.Dealer,
            Email: row.email,
            Phone: row.phone,
            Name: row.name,
            ContactPerson: row.contactperson,
            ContactPhone: row.contactphone,
            ContactAddress: row.contactaddress,
        }

        let tmp = this.state;
        tmp.newEntry = o;
        tmp.modeList = false;
        tmp.modeUpdate = true;
        this.setState(tmp);

    }
    closeView = () => {
        let tmp = this.state;
        tmp.newEntry = {
            Ref: "",
            Dealer:"",
            Email: "",
            Phone: "",
            Name: "",
            ContactPerson: "",
            ContactPhone: "",
            ContactAddress: "",
        }

        tmp.modeList = true;
        tmp.modeUpdate = false;
        this.setState(tmp);
    }

    submitEntry = async () => {
        let _this = this;
        if (!window.confirm("Are you sure that you want to add this Dealer?")) {
            return
        }
        //TODO validation here

        let hub = {...this.state.newEntry};
        hub.Phone = hub.Ref;
        hub.Vendor = "chela";
        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/agent/add";

        console.log("submitEntry send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("submitEntry response > ", dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if (data !== "ADDED") {
                    alert(data)
                } else {
                    alert("Thank you Agent added!");
                    _this.closeView();
                    _this.fetchDealers();
                    _this.fetchAgents();
                }


            }
        });

    }

    closePopup=()=>{
        this.setState({
            showPopup:false,
            selectedDealer:"",
        })
    }
    openPopup=(agent)=>{
        this.setState({
            showPopup:true,
            selectedDealer:"",
            selectedAgent:agent,
        })
    }
    renderPopupChooseDealer=()=>{

        if(!this.state.showPopup){
            return null
        }
        const actions = [
            <FlatButton
                label={"Close"}
                primary={true}
                onClick={this.closePopup}
            />,
        ];

        let _this=this;
        const getDealerName=(refIn)=>{
            for(let i in _this.state.Information.Users){
                const u =_this.state.Information.Users[i];
                if(u.Phone ===refIn){
                    return u.Fullname +"("+u.Phone+") ["+u.Username+"]";
                }
            }
            return refIn
        }


        const user =GetUserToken();
        let ls=[];
        for(let i in this.state.Information.Dealers){
            const row = this.state.Information.Dealers[i];
            if(user.Role==="super"){
                ls.push(row)
            }

            if(user.Role==="dealer" && row.Ref ===user.Phone){
                ls.push(row)
            }
        }



        return (
            <MuiThemeProvider>
                <Dialog
                    title={" Upgrade User to Agent: "+this.state.selectedAgent.FullName}
                    actions={actions}
                    modal={false}
                    open={this.state.showPopup}
                    onRequestClose={this.closePopup}
                    autoScrollBodyContent={true}
                >
                    <form onSubmit={this.onClickChooseDealer}>
                        <p className={"alert alert-info"}>User to Agent</p>

                        <div className="form-group">
                            <label>Dealers</label>
                            <br/>
                            <select
                                className="form-control"
                                onChange={(e) => this.handleChange(e,"selectedDealer")}
                                required={true}
                                value={this.state.selectedDealer}
                            >
                                <option selected value={""}>Choose...</option>

                                {ls.map((row,index)=>{

                                    return(
                                        <option value={row.Ref}>{getDealerName(row.Ref) || row.Ref}</option>
                                    )

                                })}
                            </select>
                        </div>


                        <div className="form-group">
                            <button
                                type="submit"
                                className="btn-primary form-control"
                            >Submit
                            </button>
                        </div>

                    </form>


                </Dialog>
            </MuiThemeProvider>
        )
    }

    renderList = () => {

        if (!this.state.modeList) {
            return null
        }

        return this.state.List.map((row, index) => {
            return (<tr key={index}>
                <td>{row.ref}</td>
                <td>{row.fullname}</td>
                <td>{row.email}</td>
                <td>{row.dealer}</td>
                <td>
                    <a
                        onClick={() => {
                            this.viewListDetail(row)
                        }}
                        style={{cursor: "pointer"}}
                    >View Detail</a>
                    &nbsp;&nbsp;|&nbsp;&nbsp;

                </td>
            </tr>)
        })

    }
    getNewEntryValue = (key) => {
        return this.state.newEntry[key];
    }
    setNewEntryValue = (e, key) => {
        let tmp = this.state;
        tmp.newEntry[key] = e.target.value;
        this.setState(tmp);
    }
    onClickChooseDealer=async(e)=>{
        e.preventDefault();
        const row = this.state.selectedAgent;
        let _this=this;
        const getDealerName=(refIn)=>{
            for(let i in _this.state.Information.Users){
                const u =_this.state.Information.Users[i];
                if(u.Phone ===refIn){
                    return u.Fullname +"("+u.Phone+") ["+u.Username+"]";
                }
            }
            return refIn
        }


        const msg1="Are you sure you want to upgrade this user("+row.Fullname+") as agent "+
            "for dealer("+getDealerName(this.state.selectedDealer)+") ?";
        if(!window.confirm(msg1)){
            return
        }



        let hub={
            Ref :row.Phone,
            Email :row.Username,
            Phone :row.Phone,
            Fullname :row.Fullname,
            ContactPerson :row.Fullname,
            ContactPhone :row.Phone,
            ContactAddress :"",
            Dealer:this.state.selectedDealer,

        }
        hub.Vendor = "chela";

        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/agent/add";

        console.log("submitEntry send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("submitEntry response > ", dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if(data !=="ADDED"){
                    alert(data)
                }else{
                    alert("Thank you agent added!");
                    _this.closeView();
                    _this.fetchDealers();
                    _this.closePopup();
                }
            }
        });

    }
    newEntryForm=()=> {
        if (typeof this.state.Information ==="undefined") {
            return null
        }

        const user = GetUserToken();
        let _this = this;
        const innerUserDealer=(myRef,ref)=>{
            const data = this.state.Information.DealerAgents[myRef];
            if(typeof data ==="undefined"){
                return false
            }
            if(typeof data[ref] ==="undefined"){
                return false
            }
            return true
        }

        let lsUser = [];
        for (let i in this.state.Information.Users) {
            const row = this.state.Information.Users[i];
            if(user.Role==="super"){
               lsUser.push(row);

            }else if(user.Role==="dealer"){
                if(innerUserDealer(user.Phone,row.Phone)){
                    lsUser.push(row);
                }
            }else{
                if(row.Phone ===user.Phone){
                    lsUser.push(row);
                }
            }
        }

        const canBe = (boo) => {
            if (boo) {
                return "Yes"
            }
            return "No"
        }

        return (
            <div>
                <p className={"alert alert-info"}>Choose the user from the list to Upgrade</p>
                <table className={"table table-bordered"}>
                    <thead className="table-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">AccountRef</th>
                        <th scope="col">Role</th>
                        <th scope="col">Dealer</th>
                        <th scope="col">Wallet</th>
                        <th scope="col">QualifyToBeAgent</th>
                        <th scope="col">QualifyToBeDealer</th>
                        <th scope="col">Email & Username</th>
                    </tr>
                    </thead>
                    <tbody>
                    {lsUser.map((row, index) => {
                        let boo = false;
                        let colorIn="success";
                        if (!row.QualifyDealer || !row.QualifyAgent) {
                            boo = true;
                            colorIn ="default"
                        }
                        return (
                            <tr key={index}>
                                <td>
                                    <button
                                        className={"btn btn-"+colorIn}
                                        onClick={() => this.openPopup(row)}
                                        disabled={boo}
                                    >
                                        Choose
                                    </button>
                                </td>
                                <td>{row.Fullname || "---"}</td>
                                <td>{row.Phone || "---"}</td>
                                <td>{row.Role || "---"}</td>
                                <td>{row.DealerName || "---"}</td>
                                <td>{row.WalletBalance || 0}</td>
                                <td style={{textAlign: "center"}}>{canBe(row.QualifyAgent)}</td>
                                <td style={{textAlign: "center"}}>{canBe(row.QualifyDealer)}</td>
                                <td>{row.Username || "---"}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        )


    }

    newEntryFormOld = () => {
        if (this.state.modeList) {
            return null
        }

        /*
        Ref string
	Dealer string
	Vendor string

	Fullname string
	Email string
	Phone string
	Address string
         */

        let forms = [
            {name: "Ref", desc: "Main Reference", placeHolder: "e.g. 0729139504", type: "text", required: true},
            {name: "Email", desc: "Username Or Email", placeHolder: "e.g. info@home.com Or user2019", type: "text", required: true},
            {name: "Fullname", desc: "Full Name", placeHolder: "e.g. My Full name", type: "text", required: true},
            {name: "Address", desc: "Address", placeHolder: "e.g. 05 addr line,city, provaince", type: "text", required: true},
            {name:"Province",desc:"Province",placeHolder:"e.g. Western Cape",type:"option",required:true,options:["Gauteng","Western Cape","Limpopo"]},
        ];

        const innerRender = (inObject, index) => {
            let myReadOnly = false;
            if (this.state.modeUpdate) {
                myReadOnly = true
                /*if(inObject.name ==="Ref" || inObject.name==="Email"){
                    myReadOnly=true
                }*/
            }
            if(inObject.type ==="option"){
                return(
                    <div className="form-group" key={index}>
                        <label htmlFor="exampleInputEmail1">{inObject.desc}</label>
                        <select
                            className="form-control"
                            id={inObject.name}
                            placeholder={inObject.placeHolder}
                            required={inObject.required}
                            value={this.getNewEntryValue(inObject.name)}
                            onChange={(e)=>this.setNewEntryValue(e,inObject.name)}
                            disabled={myReadOnly}
                        >
                            <option value={""}>---Select---</option>
                            {inObject.options.map((item)=>{
                                return(
                                    <option value={item}>{item}</option>
                                )
                            })}
                        </select>
                    </div>
                )
            }

            return (
                <div className="form-group" key={index}>
                    <label htmlFor="exampleInputEmail1">{inObject.desc}</label>
                    <input
                        type={inObject.type}
                        className="form-control"
                        id={inObject.name}
                        placeholder={inObject.placeHolder}
                        required={inObject.required}
                        value={this.getNewEntryValue(inObject.name)}
                        onChange={(e) => this.setNewEntryValue(e, inObject.name)}
                        disabled={myReadOnly}
                    />
                </div>
            )
        }

        let myReadOnly = false;
        if (this.state.modeUpdate) {
            myReadOnly = true
        }

        let _this = this;
        const optionsDealer=()=>{
            let ls=[];
            const role = GetUserToken().Role;
            const email = GetUserToken().Username;

            for(let i in this.state.Dealers){
                const row = this.state.Dealers[i];
                if(role ==="super"){
                    ls.push({
                        name:row.ref,
                        desc:row.name,
                    })
                }
                if(role ==="dealer"){
                    if(email ===row.email){
                        ls.push({
                            name:row.ref,
                            desc:row.name,
                        })
                    }

                }
            }

            return ls.map((row,index)=>{
                return(
                    <option value={row.name}>{row.name +" "+row.desc}</option>
                )
            })
        }


        return (
            <div className="row">

                <div className="col-xs-12 col-lg-6">

                    {!this.state.modeUpdate ?
                        <h3 className={"alert alert-info"}>New Dealer</h3>
                        :
                        <h3 className={"alert alert-danger"}>Update Dealer Info</h3>
                    }
                    <form onSubmit={this.submitEntry}>
                        {forms.map((row, index) => {
                            return innerRender(row, index)
                        })}

                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Dealer</label>
                            <select
                                className="form-control"
                                required={true}
                                value={this.getNewEntryValue("Dealer")}
                                onChange={(e) => this.setNewEntryValue(e, "Dealer")}
                                disabled={myReadOnly}
                            >
                                <option value={""}>--Select your Dealer--</option>
                                {optionsDealer()}
                            </select>
                        </div>

                        {!this.state.modeUpdate ?
                            <button
                                className={"btn btn-primary pull-right"}
                                type={"submit"}
                            >Submit</button>
                            :
                            <button
                                className={"btn btn-danger pull-right"}
                                type={"button"}
                                onClick={() => this.closeView()}
                            >Close</button>
                        }
                    </form>
                </div>
            </div>
        )
    }

    render() {

        return (


            <PageContentWallpaper {...this.props} >

                <div className="row">
                    <div className="col-xs-12">
                        <h2>Agent Management
                            {!this.state.modeList ?
                                <a className={"btn btn-danger pull-right"}
                                   onClick={() => this.setState({modeList: true, modeUpdate: false})}>Cancel</a>
                                :
                                null
                            }
                        </h2>
                    </div>

                </div>


                {this.newEntryForm()}

                {this.renderPopupChooseDealer()}

            </PageContentWallpaper>
        )


    }

}

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingDealerComponent)
